<template>
    <div style="width: 100%;">
      <li v-if="equipment == 'pc'" :class="{'nav-item nav-item-has-children': model.type === 'father' && typeof model.children !=='undefined'  && model.children.length !== 0,'nav-item': model.type === 'father', 'ch-gw-submenu-item': model.type === 'child'}" style="z-index: 9999;">
          <a :href="model.url == '' && model.module == ''?'javascript:void(0)':model.type === 'father'?model.url !== ''?model.url:model.children.length == 0?model.fatherUrl:'javascript:void(0)':model.url==''?model.children.length == 0?model.fatherUrl+'?fatherUrl='+model.module:'javascript:void(0)':model.url" @mouseenter="toggle(model)" class="ch-gw-menu-scroll"  :style="{color: model.type === 'father'?'rgb(0,0,0)':'rgb(255,255,255)' ,paddingTop: model.type === 'father'?'':0.3+'rem',paddingBottom: model.type === 'father'?'':0.3+'rem',fontSize:model.type === 'father'?'1rem':'0.95rem'}" >
              {{model.label}}
              <i v-if="model.type === 'child' && typeof model.children !=='undefined'  && model.children.length !== 0" class="lni lni-chevron-right" style="font-size: 0.1em;transform: rotate(90deg);"></i>
          </a>
        <!-- 控制是否显示下级目录 -->
        <ul v-show="model.type === 'father'?true:model.open" v-if="isFolder" :class="{'ch-gw-submenu': model.type === 'father'}" :style="{paddingLeft:(vaIndex*2)+'rem'}">
          <!-- 重点代码，调用自身，实现递归，绑定数据 -->
          <navigations @openMouseleave="openMouseleave" :equipment="equipment" ref="navigations" v-for="model in model.children" :model="model" :key="model.strId"></navigations>
      </ul>
      
      </li>
      <li v-if="equipment == 'mobile'" :class="{'nav-item nav-item-has-children': model.type === 'father' && typeof model.children !=='undefined'  && model.children.length !== 0,'nav-item': model.type === 'father', 'ch-gw-submenu-item': model.type === 'child'}" style="z-index: 9999;">
          <a :href="model.url == '' && model.module == ''?'javascript:void(0)':model.type === 'father'?model.url !== ''?model.url:model.children.length == 0?model.fatherUrl:'javascript:void(0)':model.url==''?model.children.length == 0?model.fatherUrl+'?fatherUrl='+model.module:'javascript:void(0)':model.url" @click="toggle(model,isClick)" class="ch-gw-menu-scroll"  :style="{color: model.type === 'father'?'rgb(0,0,0)':'rgba(0,0,0,0.7)' ,paddingTop: model.type === 'father'?'':0.3+'rem',paddingBottom: model.type === 'father'?'':0.3+'rem',fontSize:model.type === 'father'?'1rem':'0.95rem'}" >
              {{model.label}}
              <i v-if="model.type === 'child' && typeof model.children !=='undefined'  && model.children.length !== 0" class="lni lni-chevron-right" style="font-size: 0.8rem;transform: rotate(90deg);"></i>
          </a>
        <!-- 控制是否显示下级目录 -->
        <ul v-show="model.type === 'father'?true:model.open" v-if="isFolder"  :class="{'ch-gw-submenu': model.type === 'father','show': model.type === 'father' && isClick ,'pro_display':model.type === 'child' && isClick}" :style="{paddingLeft:(vaIndex*2)+'rem'}">
          <!-- 重点代码，调用自身，实现递归，绑定数据 -->
          <navigations @openMouseleave="openMouseleave" :equipment="equipment" ref="navigations" v-for="model in model.children" :model="model" :key="model.strId"></navigations>
      </ul>
      
      </li>
    </div>
  </template>
  <script>
  export default {
    name: "navigations",
    // 如果想使用此组件，则需要传递的数据
    props: {
      model: {
        type: Object,
        required: true
      },
      equipment:String
    },
    data() {
      return {
        // 默认不显示下级目录
        open: false,
        vaIndex:0.4,
        isClick:false
      };
    },
    computed: {
      // 控制是否有下级目录和显示下级目录
      isFolder() {
        if(typeof this.model.children != 'undefined'){
            return this.model.children && this.model.children.length;
        }
      }
    },
    methods: {
      // 点击折叠展开的方法
      toggle(model,isClick) {

        if(typeof isClick !== 'undefined'){
          this.isClick = !this.isClick
        }

        if (this.isFolder) {
            this.openMouseleave(model)
            if(model.type!='father' && !model.open){
                model.open = !model.open;
            }
            
        }
      },
      openMouseleave(model){
        this.$emit('openMouseleave',model,'model')
      },
      toggleJump(){

      }
    }
  };
  </script>
<style>
  .pro_display{
    display: block !important;
  }
</style>
  


// WEBPACK FOOTER //
// src/components/navigation/index.vue